import queryString from "query-string";

import * as types from "./actionTypes";
import { showModalSuccess, hideModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import departmentCategoryService from "../services/departmentCategoryService";
import { toggleLoader } from "./loaderActions";

export function loadDepartmentCategorySuccess(departmentCategories) {
  return {
    type: types.LOAD_DEPARTMENT_CATEGORY_SUCCESS,
    departmentCategories
  };
}

export function getDepartmentCategorySuccess(departmentCategory) {
  return {
    type: types.GET_DEPARTMENT_CATEGORY_SUCCESS,
    departmentCategory
  };
}

export function savingDepartmentCategory(status = true) {
  return {
    type: types.SAVING_DEPARTMENT_CATEGORY,
    savingDepartmentCategory: status
  };
}

export function createDepartmentCategorySuccess(departmentCategory) {
  return {
    type: types.CREATE_DEPARTMENT_CATEGORY_SUCCESS,
    departmentCategory
  };
}

export function updateDepartmentCategorySuccess(departmentCategory) {
  return {
    type: types.UPDATE_DEPARTMENT_CATEGORY_SUCCESS,
    departmentCategory
  };
}

export function loadDepartmentCategories(filters) {
  const department = filters?.department.map((dep) => dep.value).join("|");
  const status = filters?.status?.value;
  const params = filters
    ? `&${queryString.stringify(
        { department, status },
        {
          arrayFormat: "bracket"
        }
      )}`
    : "";
  return (dispatch) => {
    dispatch(toggleLoader(true));
    return departmentCategoryService
      .loadDepartmentCategories(params)
      .then((data) => dispatch(loadDepartmentCategorySuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")))
      .finally(() => dispatch(toggleLoader(false)));
  };
}

export function getDepartmentCategory(id, showDepartmentCategory = false) {
  return (dispatch) =>
    departmentCategoryService
      .getDepartmentCategory(id)
      .then((departmentCategory) => {
        dispatch(getDepartmentCategorySuccess(departmentCategory));
        if (showDepartmentCategory) {
          dispatch(showModalSuccess("departmentCategoryModal"));
        }
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function createDepartmentCategory(departmentCategory) {
  return (dispatch) => {
    dispatch(savingDepartmentCategory());
    return departmentCategoryService
      .createDepartmentCategory(departmentCategory)
      .then((createdDepartmentCategory) => {
        dispatch(createDepartmentCategorySuccess(createdDepartmentCategory));
        dispatch(savingDepartmentCategory(false));
        dispatch(
          showAlertSuccess(
            "Department Category created successfully",
            "success"
          )
        );
      })
      .catch((error) => {
        dispatch(savingDepartmentCategory(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateDepartmentCategory(departmentCategory) {
  return (dispatch) => {
    dispatch(savingDepartmentCategory());
    return departmentCategoryService
      .updateDepartmentCategory(departmentCategory)
      .then((updatedDepartmentCategory) => {
        dispatch(updateDepartmentCategorySuccess(updatedDepartmentCategory));
        dispatch(savingDepartmentCategory(false));
        dispatch(hideModalSuccess("departmentCategoryModal"));
        dispatch(
          showAlertSuccess(
            "Department Category updated successfully",
            "success"
          )
        );
      })
      .catch((error) => {
        dispatch(savingDepartmentCategory(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}
